import React from 'react';
import { Texto } from '../Texto';
import { Align, FontSize } from '../../../modules/ReceiptLayouts/Model';
import { isBoolean } from 'util';
import { BlockSpaces } from './BlockSpaces';
export const BlockService = ({ operationline, stretchName, origin, destination, fontSize, align, bold }) => (React.createElement("div", { style: {
        width: '90%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'start',
        alignItems: 'flex-start'
    } },
    React.createElement(Texto, { texto: operationline, align: align || defaultProps.align, fontSize: fontSize || defaultProps.fontSize, bold: isBoolean(bold) ? bold : defaultProps.bold }),
    React.createElement(Texto, { texto: stretchName, align: align || defaultProps.align, fontSize: fontSize || defaultProps.fontSize, bold: isBoolean(bold) ? bold : defaultProps.bold }),
    React.createElement(BlockSpaces, null),
    origin && origin !== '' &&
        React.createElement(Texto, { texto: origin, align: align || defaultProps.align, fontSize: fontSize || defaultProps.fontSize, bold: isBoolean(bold) ? bold : defaultProps.bold }),
    destination && destination !== '' &&
        React.createElement(Texto, { texto: destination, align: align || defaultProps.align, fontSize: fontSize || defaultProps.fontSize, bold: isBoolean(bold) ? bold : defaultProps.bold })));
const defaultProps = {
    align: Align.Left,
    fontSize: FontSize.normal,
    bold: false
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/Blocks/BlockService.tsx
// module id = 510
// module chunks = 0